import { RouterConfig } from '@angular/router';
import { TraconModelComponent } from './tracon-model.component';

import { AuthGuard } from '../../authentication/auth-guard.service';

export const TraconModelRoutes: RouterConfig = [
  {path: 'tracon-model', component: TraconModelComponent, canActivate: [AuthGuard]},
];


/** WEBPACK FOOTER **
 ** ./app/system-management/tracon-models/tracon-model.routes.ts
 **/